export default "__VITE_ASSET__BCi$Qt2S__"